import { Card } from '@tribeplatform/react-ui-kit/Card';
export const CardFooterBlock = Card.Footer;
//# sourceMappingURL=Block.js.map